import { IEnumItem } from "../PageLayout/context/LayoutContext";

/** 仓库类型 */
export enum WAREHOUSE_TYPE_ENUM {
  /** 自建仓 */
  'SELF_BUILT_WAREHOUSE' = 'SELF_BUILT_WAREHOUSE',
  /** 平台仓 */
  'PLATFORM_WAREHOUSE' = 'PLATFORM_WAREHOUSE',
  /** 第三方仓 */
  'THIRD_PARTY_WAREHOUSE' = 'THIRD_PARTY_WAREHOUSE',
};
/** 密码强度 */
export enum PASSWORD_STRENGTH_ENUM {
  /** 弱 */
  'WEAK' = 1,
  /** 一般 */
  'COMMONLY' = 2,
  /** 强 */
  'STRONG' = 3,
  /** 非常强 */
  'VERY_STRONG' = 4,
};
/** 密码强度字典 */
export const PASSWORD_STRENGTH: IEnumItem[] = [
  {
    value: PASSWORD_STRENGTH_ENUM.WEAK,
    label: '弱',
  },
  {
    value: PASSWORD_STRENGTH_ENUM.COMMONLY,
    label: '一般',
  },
  {
    value: PASSWORD_STRENGTH_ENUM.STRONG,
    label: '强',
  },
  {
    value: PASSWORD_STRENGTH_ENUM.VERY_STRONG,
    label: '非常强',
  },
];
/** 水印方向 */
export enum WATERMASK_DIRECTION_Enum {
  /** 水平 */
  HORIZONTAL = 'HORIZONTAL',
  /** 45度倾斜 */
  DEGREE_45 = '45_DEGREE',
  /** 垂直 */
  VERTICAL = 'VERTICAL',
  /** 135度倾斜 */
  DEGREE_135 = '135_DEGREE',
  /** 225度倾斜 */
  DEGREE_225 = '225_DEGREE',
  /** 315度倾斜 */
  DEGREE_315 = '315_DEGREE',
};
/** 水印状态 */
export enum WATERMARK_STATUS_Enum {
  /** 不添加 */
  NO = 'NO',
  /** 全部添加 */
  YES = 'YES',
  /** 部分页面添加 */
  PART = 'PART',
};
/** 水印方向 */
export enum WATERMASK_POSITION_Enum {
  /** 左上角 */
  TOP_LEFT = 'TOP_LEFT',
  /** 左下角 */
  BOTTOM_LEFT = 'BOTTOM_LEFT',
  /** 右上角 */
  TOP_RIGHT = 'TOP_RIGHT',
  /** 右下角 */
  BOTTOM_RIGHT = 'TOP_LEFT',
  /** 居中 */
  CENTER = 'CENTER',
  /** 全屏 */
  FULL_SCREEN = 'FULL_SCREEN',
};
/**  */
export enum WATERMARK_CONTENT_TYPE_Enum {
  /** 当前用户名称 */
  USER_NAME = 'USER_NAME',
  /** 自定义水印 */
  CUSTOM = 'CUSTOM',
};
/** 可见范围 */
export enum VISIBLERANGE_Enum {
  /** 全部 */
  ALL = 'ALL',
  /** 指定用户 */
  DESIGNATED_USER = 'DESIGNATED_USER',
  /** 仅自己 */
  SELF = 'SELF',
};
/** 属性输入类型 */
export enum ATTRIBUTE_INPUT_TYPE_Enum {
  /** 单选 */
  RADIOBOX = 'RADIOBOX',
  /** 多选 */
  CHECKBOX = 'CHECKBOX',
  /** 文本 */
  TEXT = 'TEXT',
  /** 日期 */
  DATE = 'DATE',
  /** 数字 */
  NUMBER = 'NUMBER',
};
